import categoryConfig from "@/config/sentenceCategory.json";

const LEVEL_CATEGORIES = categoryConfig.categories.slice(0, 10);

export function getSentenceCategoryLevelNumber(name) {
  const index = LEVEL_CATEGORIES.indexOf(name);
  return index === -1 ? 0 : index + 1;
}

export function getSentenceCategoryDisplayName(name) {
  const levelNumber = getSentenceCategoryLevelNumber(name);
  return levelNumber ? `Lv.${levelNumber} ${name}` : name;
}

export function getUniqueSentenceCategories() {
  const seen = new Set();
  return categoryConfig.categories.filter((name) => {
    if (seen.has(name)) {
      return false;
    }
    seen.add(name);
    return true;
  });
}
